export const TRADEUP_AB_TEST_NAME = 'tradeup';
export const TRADEUP_AB_TEST_NAME_ON = 'on';
export const TRADEUP_AB_TEST_NAME_OFF = 'off';
